import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useEffect } from 'react';

interface props {
  open: boolean;
  setOpen: (open: boolean) => void;
  message?: string;
  error: boolean;
}

const SUCCESS_MESSAGE = 'Dane zostały poprawnie zapisane!';
const ERROR_MESSAGE = 'Podczas zapisu danych wystąpił błąd!';

const MessageBox = (props: props) => {
  const handleClose = (e?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    props.setOpen(false);
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (props.open) {
      timer = setTimeout(() => {
        props.setOpen(false);
      }, 5000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [props.open, props]);

  return (
    <Snackbar
      open={props.open}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ zIndex: 9999 }}
    >
      <Alert
        variant="filled"
        onClose={handleClose}
        severity={props.error ? 'error' : 'success'}
        sx={{ width: '100%' }}
      >
        {props.message
          ? props.message
          : props.error
          ? ERROR_MESSAGE
          : SUCCESS_MESSAGE}
      </Alert>
    </Snackbar>
  );
};

export default MessageBox;
